import {Col, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {useFormContext} from "react-hook-form";
import { PaymentRequestPaymentTypeEnum } from "src/enums/Documents/PaymentRequest/PaymentRequestPaymentTypeEnum";
import { NFLookupBankAccountVendorCustomer } from "src/components/Shared/NewForms/NFLookupBankAccountVendorCustomer";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupBankAccount } from "src/components/Shared/NewForms/NFLookupBankAccount";
import { NFLookupCashRegister } from "src/components/Shared/NewForms/NFLookupCashRegister";

export const PaymentRequestPaymentToTheSupplier = () => {
    const {t} = useTranslation();
    const {watch} = useFormContext();
    
    const paymentType = watch("paymentType");

    return (
        <>
            <Row>
                <Col sm={6}>
                    {paymentType === PaymentRequestPaymentTypeEnum.BankAccount || paymentType === PaymentRequestPaymentTypeEnum.Any && <NFLookupBankAccount fieldName="bankAccountId" title={t("BankAccount")}/>}
                </Col>
                <Col sm={6}>
                    {paymentType === PaymentRequestPaymentTypeEnum.Cash || paymentType === PaymentRequestPaymentTypeEnum.Any && <NFLookupCashRegister fieldName="cashAccountId" title={t("CashAccount")}/>}
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupBankAccountVendorCustomer fieldName="payerAccountId" title={t("SupplierAccount")}/>
                </Col>
                <Col sm={6}>
                    <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} required/>
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFIntInput title={t("Amount")} fieldName={"amount"} required/>
                </Col>
                <Col sm={6}>
                    <NFIntInput fieldName={"amountWithVat"} title={t("AmountWithVAT")} required/>
                </Col>
            </Row>
        </>
    )
        ;
};
